import { Contact, CustomerDevice } from "@/models/Common";
import { CurrentJobDetails, Timeslot } from "@/models/JobsState";

interface DeviceAttributesMap {
	[key: string] : any
}
export function generateContact (contact: any) : Contact {
	const contactObj: Contact = {
		phone: contact.phone,
		first_name: contact.first_name,
		last_name: contact.last_name,
		full_address: contact.full_address,
		latitude: contact.latitude,
		longitude: contact.longitude,
		market_id: contact.market_id,
		zipcode: contact.zip,
		state: contact.state,
		city: contact.city,
		instructions: contact.instructions
	}

	if (contact.subscription_plan_id) {
		contactObj.subscription_plan_id = contact.subscription_plan_id;
	}

	return contactObj;
}

export function generateDevices (devices: any, deviceAttributesMap: DeviceAttributesMap): CustomerDevice[] {
	return devices.map((dev: any) => {
		const customerDeviceId = dev.customer_device_id;
		const obj: Partial<CustomerDevice> = {
			id: dev.device.id,
			title: dev.device.title,
			device_family_category_id: dev.device.device_family_category_id,
			properties: dev.properties ? JSON.parse(dev.properties) : {},
			customerDeviceId: customerDeviceId,
			attributes: deviceAttributesMap[customerDeviceId] || null,
			services: dev.services || []
		}

		return obj;
	})
}

export function generateDeviceAttributesMap (devices_attributes: any) : DeviceAttributesMap {
	return devices_attributes.reduce((acc: any, next: any) => {
		acc[next.customer_device_id] = next.attributes;
		return acc;
	}, {})
}

export function generateJobDetails (details: any) : CurrentJobDetails {
	return {
		isTechAssigned: details.is_current_technician_assigned,
		date: details.date || null,
		start_time: details.start_time || null,
		timeslots: details.timeslots && details.timeslots.length ? details.timeslots : generageTimeslots(details),
		appointment_status_id: details.appointment_status_id,
		is_job_today: details.is_job_today,
		is_follow_up: details.is_follow_up,
		is_diagnostic: details.is_diagnostic,
		account_manager: details.account_manager || 'N/A',
		diagnostic_uuid: details.diagnostic_uuid || ''
	}
}

function generageTimeslots ({ date, start_time } : {date: string, start_time: number}) : Timeslot[] {
	return [
		{
			id: 1,
			duration: 120,
			date,
			start_time
		}
	]
}
